import { useEffect, useMemo, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useTenant } from "@/contexts/TenantContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";

export default function RagSearch() {
  const { tenantId } = useTenant();
  const [kbList, setKbList] = useState<Array<{ id: string; nome: string }>>([]);
  const [kbId, setKbId] = useState<string>("");
  const [query, setQuery] = useState<string>("");
  const [results, setResults] = useState<any[]>([]);
  const [searching, setSearching] = useState(false);
  const canUse = useMemo(() => !!tenantId, [tenantId]);

  useEffect(() => {
    const loadKb = async () => {
      if (!tenantId) return;
      const { data } = await supabase.from("knowledge_bases" as any).select("id,nome").eq("tenant_id", tenantId).eq("status", "ativo");
      setKbList((data as any[]) || []);
    };
    loadKb();
  }, [tenantId]);

  const search = async () => {
    if (!tenantId || !query) return;
    setSearching(true);
    const { data, error } = await supabase.functions.invoke("ai-search", { body: { tenant_id: tenantId, query, match_count: 10 } } as any);
    if (error) {
      setSearching(false);
      return;
    }
    const matches = (data?.matches || []) as any[];
    const filtered = kbId ? matches.filter((m: any) => m?.metadata?.kb_id === kbId && m?.entity_type === "kb_chunk") : matches.filter((m: any) => m?.entity_type === "kb_chunk");
    setResults(filtered);
    setSearching(false);
  };

  if (!canUse) {
    return <div className="p-6">Selecione um tenant</div>;
  }

  return (
    <div className="p-6">
      <Card>
        <CardHeader>
          <CardTitle>RAG: Busca Semântica</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid gap-2 max-w-xl">
            <Label>Base (opcional)</Label>
            <Select value={kbId} onValueChange={(v) => setKbId(v)}>
              <SelectTrigger>
                <SelectValue placeholder="Selecionar Base (opcional)" />
              </SelectTrigger>
              <SelectContent>
                {kbList.map((kb) => (
                  <SelectItem key={kb.id} value={kb.id}>{kb.nome}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <Input placeholder="Digite sua busca" value={query} onChange={(e) => setQuery(e.target.value)} />
            <Button onClick={search} disabled={searching || !query.trim()}>{searching ? "Buscando..." : "Buscar"}</Button>
          </div>
          <div className="space-y-3">
            {results.length === 0 && !searching && (
              <div className="text-sm text-muted-foreground">Nenhum resultado encontrado</div>
            )}
            {results.map((r, idx) => (
              <div key={idx} className="rounded border p-3">
                <div className="font-medium">{r.title}</div>
                <div className="text-sm text-muted-foreground whitespace-pre-line">{r.summary}</div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
